
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import { TbMessage2Question } from "react-icons/tb";
import { BsCalendar2Event } from "react-icons/bs";
import { CgFeed } from "react-icons/cg";
import { TfiAnnouncement } from "react-icons/tfi";
import { GoPeople } from "react-icons/go";
import { TbFileInvoice } from "react-icons/tb";
import { LiaChartBarSolid } from "react-icons/lia";
import { GoInfo } from "react-icons/go";
import { TfiFiles } from "react-icons/tfi";
import { MdOutlinePermMedia } from "react-icons/md";
import { VscFeedback } from "react-icons/vsc";
import { BiDonateHeart } from "react-icons/bi";

const fontSize = 23;

export const ICONS = {
    'posts': <CgFeed fontSize={fontSize}/>,
    'announcements': <TfiAnnouncement fontSize={fontSize}/>,
    'events': <BsCalendar2Event fontSize={fontSize}/>,
    'directory': <GoPeople fontSize={fontSize}/>,
    'bulletin': <TbFileInvoice fontSize={fontSize}/>,
    'polls': <LiaChartBarSolid fontSize={fontSize}/>,
    'about': <GoInfo fontSize={fontSize}/>,
    'files': <TfiFiles fontSize={fontSize}/>,
    'videos': <VideoLibraryIcon fontSize={fontSize}/>,
    'feedback': <VscFeedback fontSize={fontSize}/>,
    'media': <MdOutlinePermMedia fontSize={fontSize}/>,
    'giving': <BiDonateHeart fontSize={fontSize} />,
    'sessions': <TbMessage2Question fontSize={fontSize}/>,
    'qaSessions': <TbMessage2Question fontSize={fontSize}/>
}
